/* 🤖 this file was generated by svg-to-ts */
export const iconFail: {
  name: 'fail';
  data: string;
} = {
  name: 'fail',
  data: `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 0c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8Zm0 2C4.691 2 2 4.691 2 8s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6ZM5.293 5.293a.999.999 0 0 1 1.414 0L8 6.586l1.293-1.293a.999.999 0 1 1 1.414 1.414L9.414 8l1.293 1.293a.999.999 0 1 1-1.414 1.414L8 9.414l-1.293 1.293a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L6.586 8 5.293 6.707a.999.999 0 0 1 0-1.414Z"/></svg>`,
};
